exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skeleton-workspace-history[data-v-659898df]{display:flex;align-items:flex-start}.skeleton-workspace-history .skel-workspace-history-avatar[data-v-659898df]{margin-right:.375rem}.skeleton-workspace-history .skel-workspace-history-info[data-v-659898df]{flex:1}.skeleton-workspace-history .skel-workspace-history-info .skel-workspace-history-row-alpha[data-v-659898df]{margin-bottom:.475rem}", ""]);

// exports
